import { CabinetContent } from 'containers/CabinetContent/styled';
import { routeDependsOnFeatures } from 'navigation/config';
import { useEnforceAccess } from 'navigation/useEnforceAccess';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { LayoutProps } from 'router/types';

import { isAuthenticationCompleteSelector } from 'store/auth/selectors';
import { selectIsNavReady } from 'store/features/selectors';

import { initDecagonClient } from 'services/decagonClient';

import Header from 'components/Header/Header';
import { PageLoader } from 'components/PageLoader';
import Sidebar from 'components/Sidebar/SideBar';

const CabinetLayout = ({ children, titleKey, withCenteredContent = false }: LayoutProps) => {
    const { t } = useTranslation();
    const { pathname } = useLocation();

    const isAuthComplete = useSelector(isAuthenticationCompleteSelector);
    const isNavReady = useSelector(selectIsNavReady);

    useEnforceAccess();

    initDecagonClient();

    // Keep `/features` off the critical path of pages that don't gate on it.
    // Feature/flag-gated routes wait for full nav-readiness (so the gate is
    // resolved before render); everything else renders as soon as auth settles
    // and lets `useEnforceAccess` handle any later access changes.
    const blocked = routeDependsOnFeatures(pathname) ? !isNavReady : !isAuthComplete;

    if (blocked) {
        return <PageLoader />;
    }

    return (
        <>
            <Helmet title={t(titleKey)} />
            <Header />
            <CabinetContent $withCenteredContent={withCenteredContent}>
                <Sidebar />
                {children}
            </CabinetContent>
        </>
    );
};

export default CabinetLayout;
